import type { TVenues, VenueRequest } from "@/models/venues.model"
import type { HttpClient } from "@/services/http-common"
import ApiServiceFactory from "@/services/api-service-factory"

export class VenuesService {
  private httpClient: HttpClient

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async fetchVenues() {
    const response = await this.httpClient.get<TVenues[]>("/get-all")
    console.log("VenuesService.fetchVenues", response)
    return response
  }

  async createVenue(data: VenueRequest) {
    return this.httpClient.post("/create", data)
  }

  async updateVenue(code: string, data: VenueRequest) {
    return this.httpClient.patch(`/update/${code}`, data)
  }
}

export const venuesService = ApiServiceFactory.createService(VenuesService, "venues")
export default VenuesService
